import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { LINES_RESEARCH_LIST } from './LinesResearchContent.data'
import { useStyles } from './LinesResearchContent.styles'

const LinesResearchContent = () => {
  const { t } = useTranslation()
  const classesGlobal = useGlobalStyles()
  const classes = useStyles()

  return (
    <>
      <Box className={classesGlobal.containerPages}>
        <BreadcrumbsComponent
          crumbs={[
            { label: t('navbar.start'), path: '/' },
            { label: t('lines-research.title') }
          ]}
        />
        <Typography className={classesGlobal.titleSection}>
          {t('lines-research.title')}
        </Typography>
        <Grid container className={classes.gridContainer} spacing={3}>
          {LINES_RESEARCH_LIST.map((line, index) => (
            <Grid
              item
              className={classes.gridItem}
              key={index}
              xs={12}
              sm={6}
              md={4}
              xl={2}
            >
              <Box className={classes.iconBackground}>
                <img src={line.src} alt={line.text} className={classes.icon} />
              </Box>
              <Typography variant="body1" className={classes.iconText}>
                {t(line.text)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default LinesResearchContent
